export default __webpack_public_path__ + "images/0f708d5e8deddf149e7c86babbd6a72e.png";